module.exports = __webpack_public_path__ + "media/images/sample/profile_pic_2-89fcaa53b00f9751360f25b72d3e0bf2.png";